module.exports = __webpack_public_path__ + "static/media/sqlserver.aa529504.png";